import {getViewModel} from '@netx/core/lib/utils';

import type AttributeModel from '@netx/core-asset/models/attribute';
import type View from '@netx/core/lib/netx-view';

import {canEdit} from '../enablers';
import {PROFILE_ACTION} from '../locales';

import type {Action} from '@netx/core/bootstrap';

import {icon} from '@fortawesome/fontawesome-svg-core';
import {faPencilAlt} from '@fortawesome/pro-solid-svg-icons';
import {UserLevel} from '@netx/core-user-next/constants';

const iconOpts = {classes: ['fa-fw']};
const icons = {
	faPencilAlt: icon(faPencilAlt, iconOpts).html,
};

const wrapper = (view: View<AttributeModel>, event: MouseEvent) => [
	getViewModel<AttributeModel>(view),
	event,
];

export const BASE_EVENT = `attribute:profile`;

export const ATTRIBUTE_PROFILE_EVENT = <const>{
	ADD: `${BASE_EVENT}:new`,
	EDIT: `${BASE_EVENT}:edit`,
};

export const ACTIONS: Action<
	(typeof ATTRIBUTE_PROFILE_EVENT)[keyof typeof ATTRIBUTE_PROFILE_EVENT]
>[] = [
	{
		event: ATTRIBUTE_PROFILE_EVENT.ADD,
		enableTest: canEdit,
		get label() {
			return PROFILE_ACTION.ADD;
		},
		testOnSync: true,
		userLevel: UserLevel.ADMIN,
	},
	{
		event: ATTRIBUTE_PROFILE_EVENT.EDIT,
		enableTest: canEdit,
		icon: icons.faPencilAlt,
		get label() {
			return PROFILE_ACTION.EDIT;
		},
		testOnSync: true,
		userLevel: UserLevel.ADMIN,
		wrapper,
	},
];

export default ACTIONS;
